import alt from '../alt';
import $ from 'jQuery';
import si from 'si';

class ProductBrowseActions {
	getCategories(callback) {
		si.getProductCategories().then(this.categoriesSuccess, this.categoriesFailure);
		return true;
	}

	getNewProducts(sendData) {
		if($("#products-area").length > 0){
			let searchTerms = sendData.searchTerm.length == 1 && sendData.searchTerm[0] === '' ? [] : sendData.searchTerm
			si.findProducts(sendData, searchTerms).then((products) => {
				this.productsSuccess(products, sendData);
			}, this.productsFailure);

		} else {
			let term = sendData.searchTerm !== "undefined" ? sendData.searchTerm : '';
			window.location = window.jenkon.consultantRoot + "Products#" + term + "|0|1";
		}
		return true;
	}

	getMoreProducts(sendData) {
		let searchTerms = sendData.searchTerm.length == 1 && sendData.searchTerm[0] === '' ? [] : sendData.searchTerm
		si.findProducts(sendData, searchTerms).then(this.moreProductsSuccess, this.productsFailure);
		return true;
	}

	getProductsForCategory(CategoryID, callback) {
		this.setParentCategory(CategoryID);
		return {
			CategoryID: CategoryID,
			callback: callback
		};

	}

	categoriesSuccess(categories) {
		return categories;
	}

	categoriesFailure() {
		return "The categories could not be loaded";
	}

	productsSuccess(products, sentData) {
		this.setParentCategory(sentData.categoryID);
		let productData = {
			products: products,
			sentData: sentData
		}
		return productData;
	}

	productsFailure() {
		return "The products could not be loaded";
	}

	moreProductsSuccess(products) {
		return products;
	}

	resetAll(){
		return true;
	}

	initialSetup(callback){
		return callback;
	}
	setParentCategory(CategoryID){
		return CategoryID;
	}
}

export default alt.createActions(ProductBrowseActions);



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/ProductBrowseActions.js